
<input id="toggle-sidebar-checkbox" type="checkbox" role="button" class="toggle-sidebar-checkbox" />
<label for="toggle-sidebar-checkbox" class="toggle-sidebar"></label>

<!-- Desktop View -->
@if (isDesktop) {
  <div class="sidebar">
    <div class="traffic-location">
      <label for="place-search-desktop">Enter a location:</label>
      <app-google-place-search [placeHolder]='' title='' showCurrentLocation=true minCharsEntryForSearch=2
        [locationModel]="this.locationModel"
        id="place-search-desktop"
        (onSubmit)="onFindLocation()"
        [currentLocation]='this.locationModel.Name' useCurrentLocationIcon="true"
      (onValueChanged)='getSelectToPlace($event)'></app-google-place-search>
      <aa-route-plan-button [title]="'Find'" [isLoading]="this.locationModel.isLoading" (click)="onFindLocation()"></aa-route-plan-button>
    </div>
    <aa-traffic-options (optionSelected)="trafficOptionsChanged($event)" [optionData]="trafficNewsModel.trafficOptionsData"></aa-traffic-options>
  </div>
}


<!-- Mobile View -->
@if (!isDesktop) {
  <div class="toggle_content" >
    <div class="wrapper" [ngClass]="{'close': !mapMobileMenu.toggleMenu}">
      @if (mapMobileMenu.searchActive) {
        <div  class="traffic-location">
          <label [ngClass]="{'location-not-found':isLocationFeature}" for="place-search-mobile">Enter a location:</label>
          <app-google-place-search [placeHolder]='' title='' showCurrentLocation=true minCharsEntryForSearch=2
            [locationModel]="this.locationModel"
            id="place-search-mobile"
            (onSubmit)="onFindLocation()"
            [currentLocation]='this.locationModel.Name' useCurrentLocationIcon="true"
          (onValueChanged)='getSelectToPlace($event)'></app-google-place-search>
          <aa-route-plan-button [title]="'Find'" [isLoading]="this.locationModel.isLoading" (click)="onFindLocation()"></aa-route-plan-button>
        </div>
      }
      @if (mapMobileMenu.mapActive) {
          <aa-traffic-options (optionSelected)="trafficOptionsChanged($event)" [optionData]="trafficNewsModel.trafficOptionsData"></aa-traffic-options>
      }
    </div>
    <button class="toogle_button" (click)="mapMobileMenu.toggleMenus()" [ngClass]="{'closed': !mapMobileMenu.toggleMenu}">
      <span class='icon-up'></span>
    </button>
  </div>
}


<!-- Desktop & Mobile View -->
<div class="content">
  <div class="map-container">
    <aa-hybrid-google-map #hybridGoogleMap [mapType]="1" ></aa-hybrid-google-map>
    <aa-traffic-alert-last-updated></aa-traffic-alert-last-updated>
  </div>
</div>

<!-- Mobile View -->
@if (!isDesktop) {
  <div class="ads-sticky-mobile">
    <aa-app-advertisement class="ads-sticky-mobile" type="the-aa-mpu-mobile"></aa-app-advertisement>
  </div>
}